import type { CookieStep } from './service/models/cookie-step.model';

export class InitializeCookiesFromStorage {
  static readonly type = '[Cookies] - Initialize Cookies From Storage';
}

export class OpenCookiesDialog {
  static readonly type = '[Cookies] - Open Cookies Dialog';
}

export class CloseCookiesDialog {
  static readonly type = '[Cookies] - Close Cookies Dialog';
}

export class SetCookieConsent {
  static readonly type = '[Cookies] - Set Cookie Consent';

  constructor(
    public cookieId: string,
    public accepted: boolean
  ) {}
}

export class AcceptAllCookies {
  static readonly type = '[Cookies] - Accept All Cookies';
}

export class RejectCookies {
  static readonly type = '[Cookies] - Reject Cookies';
}

export class ConfirmPreferences {
  static readonly type = '[Cookies] - Confirm Preferences';
}

export class ChangeCookiesStep {
  static readonly type = '[Cookies] - Change Cookies Step';

  constructor(public step: CookieStep) {}
}
